import request from './request'

export default {
  /**
   * 获取配置信息
   */
  config(game, param) {
    return request.getJson(`/configure/v1/${game}.json`, param)
  },
  /**
 * 获取内容列表
 */
  infoList(param) {
    return request.get('gzhnews/v1/list', param)
  },
  /**
   * 获取配置信息
   */
  news(id, param) {
    return request.getJson(`/news/${id}.json`, param)
  },
  /**
   * 浏览上报
   */
  pv(data) {
    return request.bodyPost('gzhnews/v1/data/pv', data)
  },
  /**
   * 获取pv
   */
  getPv(id) {
    return request.get(`gzhnews/data/news/${id}`)
  },

}
